module.exports = __webpack_public_path__ + "assets/img/2164a264123f71c8e985389266521665.svg";